import {
  FileCheck,
  FileText,
  Lightbulb,
  Target,
  Users,
  Calendar,
  Code,
  Presentation,
  Video,
} from "lucide-react";

export const documentTypes = [
  { value: "note", label: "Note", icon: FileText, color: "hsl(220, 70%, 50%)" },
  { value: "youtube", label: "YouTube", icon: Video, color: "hsl(0, 72%, 51%)" },
  { value: "research", label: "Research", icon: FileCheck, color: "hsl(280, 67%, 55%)" },
  { value: "plan", label: "Plan", icon: Target, color: "hsl(142, 71%, 45%)" },
  { value: "idea", label: "Idea", icon: Lightbulb, color: "hsl(45, 93%, 47%)" },
  { value: "meeting", label: "Meeting Notes", icon: Users, color: "hsl(24, 95%, 53%)" },
  { value: "journal", label: "Journal", icon: Calendar, color: "hsl(0, 84%, 60%)" },
  { value: "code", label: "Code Snippet", icon: Code, color: "hsl(271, 76%, 53%)" },
  { value: "presentation", label: "Presentation", icon: Presentation, color: "hsl(199, 89%, 48%)" },
];
